var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.598 32.627",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M2.237,34.627H32.484a2.176,2.176,0,0,0,1.921-3.2L19.314,3.151A2.172,2.172,0,0,0,17.4,2h0a2.173,2.173,0,0,0-1.916,1.148L.321,31.425a2.174,2.174,0,0,0,1.916,3.2Zm15.159-8.7A2.175,2.175,0,1,1,15.22,28.1,2.176,2.176,0,0,1,17.4,25.926ZM15.22,21.611v-8.7a2.175,2.175,0,0,1,4.35,0v8.7a2.175,2.175,0,0,1-4.35,0Z",
    transform: "translate(-0.063 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorTriangle);
export default __webpack_public_path__ + "static/media/icon_error-triangle.b9088816.svg";
export { ForwardRef as ReactComponent };